import { Injectable } from '@angular/core';
import { HostPayaraInspira, HttpHeaderToken } from 'src/app/general/variables';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class AsignarInfoBPMService {

  constructor(protected http: HttpClient) { }

  url: String = `${HostPayaraInspira}`;





}
